import { NetworkId } from 'modules/network';
import { ProductId } from 'modules/program';
import { Tracking } from 'modules/tracking';

import { BannersTrackings } from './config/banners-tracking.config';
import { SearchWidgetTrackings } from './config/search-widget-tracking.config';

type TProductTrackings = { [key: string]: Record<NetworkId, Tracking> };

const Trackings: Record<ProductId, TProductTrackings> = {
  [ProductId.Banners]: BannersTrackings,
  [ProductId.SearchWidget]: SearchWidgetTrackings,
};

export { Trackings };
